import Modal, { ModalTitle } from './modal'
import MultiStepModal from './multi-step-modal'

export { BubbleModal } from './bubble-modal'
export { GroupGiftModal } from './group-gift-modal'

export { Modal, MultiStepModal, ModalTitle }
export { ModalHeader, ModalBody, ModalFooter } from 'react-bootstrap'
